import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import { SvgIcon } from '@/components';
import parse from 'html-react-parser';

import styles from './AddressConnections.module.sass';

interface AddressConnectionsProps {
  low?: number;
  medium?: number;
  high?: number;
}

const AddressConnections = ({ low, medium, high }: AddressConnectionsProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.connections}>
      <div className={styles.heading}>
        {t('translation.wallet_connection_title')}
      </div>

      <div className={styles.list}>
        <Connection
          type="low"
          title={t('translation.low_risk_exposure')}
          value={low}
        />

        <Connection
          type="medium"
          title={t('translation.medium_risk_exposure')}
          value={medium}
        />

        <Connection
          type="high"
          title={t('translation.high_risk_exposure')}
          value={high}
        />
      </div>
    </div>
  );
};

const Connection = ({
  type,
  title,
  value,
}: {
  type: string;
  title: string;
  value?: number;
}) => {
  const { t } = useTranslation();

  const pluralLabel =
    value === 1 ? t('translation.connection') : t('translation.connections');

  const isHigh = type === 'high';

  const classes = cx(styles.connection, styles[`connection--${type}`]);

  return (
    <div className={classes}>
      <div className={styles.title}>{title}</div>
      <div className={styles.value}>
        {isHigh && (
          <>
            <SvgIcon name="lock" className={styles.lockIcon} />{' '}
            {t('translation.connections')}
          </>
        )}
        {!!value && !isHigh && parse(`<b>${value}</b> ${pluralLabel}`)}
      </div>
    </div>
  );
};

export default AddressConnections;
